import { Component, Input } from "@angular/core";
import { Type } from "../../../../shared/components";
import { getApp } from "../app";
import { Customer } from "../../../../shared/types/customers";
@Component({
  selector: "app-filter-fields",
  templateUrl: "./filter-fields.component.html",
  styleUrls: ["./filter-fields.component.scss"]
})
export class FilterFieldsComponent {
  fieldList: string[] = [];
  optionSearchTerm = "";
  @Input() types: Type[] = [];

  app = getApp((app) => {
    this.app = app;
  });

  constructor() {}

  getFieldOptions() {
    return new Map<string, Set<any>>();
  }

  getFeatureFields() {
    const types = new Set(this.types);
    if (!types.has("thread")) {
      return [];
    }
    return [
      this.app.fieldId.thread.changeClasses,
      this.app.fieldId.thread.omfStatus,
      this.app.fieldId.post.resolveClass
    ];
  }

  getFilterFields() {
    return (this.app.state.filterByPage?.length ?? 0) > 0;
  }

  getDisplayValue(field: string, value: any): string {
    if (field === null) {
      return "" + value;
    }

    if (value instanceof Set) {
      const arr = Array.from(value);
      if (arr.length === 1) {
        value = arr[0];
      } else {
        return arr.map((v) => this.getDisplayValue(field, v)).join(", ");
      }
    }

    if (
      this.app.field.isMultiple(field) &&
      this.app.field.getType(field) === "user-options"
    ) {
      const id = Array.isArray(value) ? value[0] : value;
      return this.app.users.getOptionName(id);
    }
    //set multiple to false to get single value as text only for filter display
    if (this.app.field.isMultiple(field)) {
      this.app.field.getFieldSettings(field).multiple = false;
    }
    return this.app.field.getFieldValueAsText(field, value);
  }

  getFilteredCurrentOptions(): any[] {
    const field = this.app.filterList.field;
    const term = this.optionSearchTerm.toLowerCase();
    const type = this.getFieldType(field);

    if (
      this.app.customer === Customer.DB &&
      field === this.app.fieldId.thread.dinCodeRespName
    ) {
      return this.app.users
        .getOptions("team")
        .filter((u: any) => !term || u.name?.toLowerCase().includes(term));
    }

    switch (type) {
      case "user-options":
        return this.app.users.allUserNames.filter(
          (u: any) => !term || u.name?.toLowerCase().includes(term)
        );
      case "dataList":
        return this.app.field
          .getDatalistOptions(field!)
          .filter((opt: string) => !term || opt.toLowerCase().includes(term));
      default:
        return this.app.filterTable
          .getOptions(field!)
          .filter(
            (opt: string) =>
              !term ||
              this.app.filterTree
                .getOptionText(field!, opt)
                .toLowerCase()
                .includes(term)
          );
    }
  }

  getFieldType(field: string | null) {
    if (field === null) {
      return "";
    }
    return this.app.field.getType(field);
  }

  getActiveFilters() {
    if (this.app.type === "thread") {
      return this.app.state.filterByPage;
    }
    return this.app.filterHeaderTable.filters;
  }

  async selectOption(field: string, value: string) {
    if (this.app.type === "thread") {
      const index = this.app.state.filterByPage.findIndex(
        (f) => f.filterLabelField === field && f.values === value
      );
      if (index !== -1) {
        this.app.state.filterByPage.splice(index, 1);
      } else {
        this.app.state.filterByPage.push({
          values: value,
          filterView: this.app.state.view,
          filterLabelField: field
        });
      }
      this.app.state.next();
      this.app.spinner.showSpinner();
      await this.app.thread.getThreadSearchResult();
      this.app.spinner.hideSpinner();
      this.app.paginator.resetPagination();
    } else {
      this.app.filterHeaderTable.filter(field, value);
    }
  }

  async clearFilter(fieldId: string) {
    if (this.app.type !== "thread") {
      await this.app.filterHeaderTable.clearFilter(fieldId);
    }
    this.app.model[fieldId] = "";

    const index = this.app.state.filterByPage.findIndex(
      (filterItem) => filterItem.filterLabelField === fieldId
    );
    if (index !== -1) {
      this.app.state.filterByPage.splice(index, 1);
    }

    if (this.app.state.filterByPage.length === 0) {
      this.app.state.next({
        filterByPage: [],
        filters: {},
        filter: { values: new Set() }
      });
    } else {
      this.app.state.next();
    }

    if (this.app.filterFields.isQuickFilterField(fieldId)) {
      this.app.filterFields.quickFilterSelected = "";
    }

    this.app.spinner.showSpinner();
    await this.app.thread.getThreadSearchResult();
    this.app.spinner.hideSpinner();

    if (!this.app.filterFields.isQuickFilterField(fieldId)) {
      this.app.filterList.field = fieldId;
      this.app.filterList.open = true;
      this.optionSearchTerm = "";
    }
  }
}
